import { MutateFormFields } from '../ui/modal-mutate-feedback-subject/types';
import { CreateFeedbackSubjectDataRequest } from '@entities/feedback-subject/api/feedback-subject-types';

export const normalizeSubmitValues = (values: MutateFormFields): CreateFeedbackSubjectDataRequest => {
    return {
        title: values.title,
        description: values.description,
        code: values.code,
        sort: Number(values.sort || 0),
        active: values.active === 'true',
        users: values.users?.map((user) => user.id),
    };
};
